import { inject, Injectable } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { Observable, of } from 'rxjs';
import { catchError, filter, first, timeout } from 'rxjs/operators';

import { ObjectUtils } from '@bn/primitives';
import { UserDetails } from '@bn/shared/core/api';

import { UserStateService } from '../stores/user-state.service';

@Injectable({ providedIn: 'root' })
export class UserStateResolver implements Resolve<Partial<UserDetails>> {
  #userDetails$: Observable<Partial<UserDetails>>;
  #userStore = inject(UserStateService).userStore;

  constructor() {
    this.#userDetails$ = toObservable(this.#userStore.userDetails);
  }

  /**
   * Resolves user state beforehand.
   * @param next The activated route snapshot.
   * @param state The router state snapshot.
   * @returns User details state.
   */

  resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<Partial<UserDetails>> {
    return this.#userDetails$.pipe(
      filter((userDetails) => ObjectUtils.isEnum(userDetails)),
      first(),
      timeout(30_000),
      // Do not block route activation forever if user details fail to hydrate.
      catchError(() => of({} as Partial<UserDetails>)),
    );
  }
}
